<app-select [required]="required" [optionsProvider]="getConnectionValues()" [(ngModel)]="value" dataKey="name"
            [formatter]="connectionValueFormatter" (ngModelChange)="writeValue($event)" [disabled]="disabled"></app-select>